import { render } from "./CameraPopup.vue?vue&type=template&id=27bcf5b6&ts=true"
import script from "./CameraPopup.vue?vue&type=script&lang=ts"
export * from "./CameraPopup.vue?vue&type=script&lang=ts"

import "./CameraPopup.vue?vue&type=style&index=0&id=27bcf5b6&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__